import { render, staticRenderFns } from "./NoResultForum.vue?vue&type=template&id=61ba8292&"
import script from "./NoResultForum.vue?vue&type=script&lang=js&"
export * from "./NoResultForum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports